import styled from 'styled-components'

const CurrencySwitcherStyled = styled.div`
  float: right;
  background-color: #293143;
  
  select {
    
    
    border: none;
    border-radius: 15px;
    padding: 10px;    
  }

 
`

export default CurrencySwitcherStyled;